"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_1 = __importDefault(require("i18next"));
var react_i18next_1 = require("react-i18next");
//import en from "../lang/en.json";
var th_json_1 = __importDefault(require("../lang/th.json"));
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
var resources = {
    //   en: {
    //     translation: en,
    //   },
    th: {
        translation: th_json_1.default
    }
};
i18next_1.default.use(react_i18next_1.initReactI18next) // passes i18n down to react-i18next
    .init({
    resources: resources,
    lng: "th", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    interpolation: {
        escapeValue: false // react already safes from xss
    }
});
exports.default = i18next_1.default;
